import * as Yup from 'yup'

const paymentBankTransferCreateScheme = Yup.object().shape(
  {
    order_number            : Yup.number().required('order number required'),
    customer_name           : Yup.string().required('customer name required'),
    customer_email          : Yup.string().email('customer email must be a valid email').required('customer email required'),
    credit_bank_name        : Yup.string().required('bank name required'),
    transfer_amount         : Yup.string().required('transfer amount required'),
    transfer_date           : Yup.string().required('transfer date required'),
    credit_bank_name_others : Yup.string()
      .when('credit_bank_name', {
        is   : (value) => value === 'OTHERS',
        then : Yup.string().required(
          'bank name required'
        ),
        otherwise: Yup.string()
      }),
    credit_account_name : Yup.string().required('bank holder name required'),
    debit_tl_bank       : Yup.string().required('TL bank name required')
  }
)

export default paymentBankTransferCreateScheme
